import { useEffect, useRef, useState } from "react";
import { Form, FormGroup, FormControl } from "react-bootstrap";
import { Axios } from "../../../Api/axios";
import { ADMIN_ALL_SUBJECTS, ADMIN_SUBJECT_BY_ID } from "../../../Api/Api";
import LoadingSubmit from "../../../Components/Loading/Loading";
import { useNavigate, useParams } from "react-router-dom";
import DashDialog from "../../../Components/Dashboard/DashDialog";

export default function Material() {
  const { id }                  = useParams();
  const [name, setName]         = useState("");
  const [teacherName, setTeacherName] = useState("");
  const [teacherPhone, setTeacherPhone] = useState("");
  const [teacherPhoto, setTeacherPhoto] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [fetching, setFetching] = useState(true);
  const [phoneError, setPhoneError] = useState("");

  const focus = useRef(null);
  const nav   = useNavigate();

  useEffect(() => {
    Axios.get(ADMIN_ALL_SUBJECTS)
      .then((res) => {
        const subjects = res.data.subjects || [];
        const found = subjects.find((s) => String(s.id) === String(id));
        if (found) {
          setName(found.name || "");
          setTeacherName(found.teacher_name || "");
          setTeacherPhone(found.teacher_phone || "");
        }
      })
      .catch(() => nav("/dashboard/categories", { replace: true }))
      .finally(() => {
        setFetching(false);
        focus.current?.focus();
      });
  }, [id, nav]);

  function validatePhone(value) {
    if (!value.trim()) return "";
    const syrian = /^(09\d{8}|\+9639\d{8})$/;
    return syrian.test(value.trim()) ? "" : "الرقم يجب أن يكون سورياً (يبدأ بـ 09 أو +963)";
  }

  async function handleSubmit() {
    if (!name.trim()) return;
    const phoneErr = validatePhone(teacherPhone);
    if (phoneErr) { setPhoneError(phoneErr); return; }
    setLoading(true);
    const formData = new FormData();
    formData.append("name",          name.trim());
    formData.append("teacher_name",  teacherName);
    formData.append("teacher_phone", teacherPhone);
    if (teacherPhoto) formData.append("teacher_photo", teacherPhoto);
    try {
      await Axios.put(ADMIN_SUBJECT_BY_ID(id), formData);
      nav("/dashboard/categories");
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  return (
    <>
      {loading && <LoadingSubmit />}
      <DashDialog
        title="تعديل بيانات المادة"
        onSubmit={handleSubmit}
        submitDisabled={name.trim().length < 1 || !!phoneError || fetching || loading}
        submitLabel={loading ? "جاري الحفظ..." : "حفظ التعديلات"}
      >
        <Form.Group className="mb-4" controlId="subjectName">
          <Form.Label>المادة</Form.Label>
          <Form.Control
            ref={focus}
            value={fetching ? "" : name}
            required
            onChange={(e) => setName(e.target.value)}
            type="text"
            placeholder={fetching ? "جاري التحميل..." : "اسم المادة..."}
            disabled={fetching}
          />
        </Form.Group>

        <Form.Group className="mb-4" controlId="teacherName">
          <Form.Label>اسم المدرس</Form.Label>
          <Form.Control
            value={fetching ? "" : teacherName}
            onChange={(e) => setTeacherName(e.target.value)}
            type="text"
            placeholder="اسم المدرس..."
            disabled={fetching}
          />
        </Form.Group>

        <Form.Group className="mb-4" controlId="teacherPhone">
          <Form.Label>رقم المدرس</Form.Label>
          <Form.Control
            value={fetching ? "" : teacherPhone}
            onChange={(e) => {
              setTeacherPhone(e.target.value);
              setPhoneError("");
            }}
            type="text"
            placeholder="مثال: 0933123456 أو +963933123456"
            disabled={fetching}
            isInvalid={!!phoneError}
          />
          {phoneError && (
            <Form.Control.Feedback type="invalid">{phoneError}</Form.Control.Feedback>
          )}
        </Form.Group>

        <FormGroup className="mb-2" controlId="teacherPhoto">
          <Form.Label>صورة المدرس (اتركه فارغاً للإبقاء على الصورة الحالية)</Form.Label>
          <FormControl
            onChange={(e) => setTeacherPhoto(e.target.files[0] || null)}
            type="file"
            accept="image/*"
            disabled={fetching}
          />
        </FormGroup>
      </DashDialog>
    </>
  );
}
